/**
 * Custom error classes for Google Play API
 */

export class GPError extends Error {
    constructor(message: string) {
        super(message);
        this.name = this.constructor.name;
    }
}

export class GPTokenExpiredError extends GPError {
    constructor(message = "Google Play token has expired") {
        super(message);
    }
}

export class GPNilPayloadError extends GPError {
    constructor(message = "Received nil payload from Google Play API") {
        super(message);
    }
}

export class GPAuthenticationError extends GPError {
    constructor(message = "Authentication failed") {
        super(message);
    }
}

export class GPNetworkError extends GPError {
    constructor(message = "Network request failed", public status?: number) {
        super(message);
    }
}

export class GPValidationError extends GPError {
    constructor(message = "Validation failed") {
        super(message);
    }
}

export class GPMissingAppDeliveryDataError extends GPError {
    constructor(message = "Buy response is missing AppDeliveryData") {
        super(message);
    }
}